import { useEffect, useRef, useState } from "react"
import * as s from "./site.module.scss"

const forbiddenWords = [
  "нет",
  "нету",
  "нт",
  "carrotquest.io",
  "test.com",
  "test.ru",
  "test.io",
  "carrotquest",
  "carrot guest",
  "все",
  "нет компании",
  "отсутствует",
  "свой",
  "сайт",
  "жопа",
  "хуй",
  "добрый день",
  "привет",
  "здравствуйте",
  "пожалуйста",
  "любая",
  "любой",
  "google.com",
  "google.ru",
  "ya.ru",
  "лид",
  "kepot cvect",
  "незнаю",
  "не знаю",
  "тест",
  "neznaiu",
  "ne znaiu",
  "пока что нет",
  "пока нет",
  "хз",
  "vk.ru",
  "vk.com",
  "web.whatsapp.com",
  "whatsapp.com",
  "whatsapp.ru, www.carrquest.io",
]

const cleanUrl = (url: string) => {
  let cleaned = url.replace(/^(https?:\/\/)?(www\.)?/i, "")
  cleaned = cleaned.split(/[?#]/)[0]
  cleaned = cleaned.replace(/\/+$/, "")
  return cleaned.trim()
}

export const isValidSite = (value: string) => {
  if (!value) return false
  const normalizedValue = cleanUrl(value)

  if (/[^a-zA-Z0-9а-яА-Я./-]/.test(normalizedValue)) return false
  if (normalizedValue.includes("..")) return false
  if (normalizedValue.length < 4 || normalizedValue.length > 100) return false
  if (forbiddenWords.some((word) => normalizedValue.toLowerCase().includes(word))) return false
  if (!/\.[a-zA-Zа-яА-Я]{2,}$/.test(normalizedValue)) return false

  return true
}

const SiteInputValidate = ({ className = "", onChange, initialValue = "" }) => {
  const [site, setSite] = useState(() => (initialValue ? cleanUrl(initialValue) : ""))
  const [error, setError] = useState(false)
  const [isTouched, setIsTouched] = useState(false)

  // onChange приходит инлайн-стрелкой, в зависимости эффекта её класть нельзя.
  const onChangeRef = useRef(onChange)
  onChangeRef.current = onChange

  // Адрес сайта, введённый на первом экране, подставляем в поле и сразу валидируем.
  useEffect(() => {
    if (!initialValue) return

    setSite(cleanUrl(initialValue))
    setIsTouched(true)

    const valid = isValidSite(initialValue)
    setError(!valid)
    onChangeRef.current(valid ? initialValue : "")
  }, [initialValue])

  const handleInputChange = (e) => {
    const value = e.target.value
    const cleanedValue = cleanUrl(value)
    if (!isTouched) setIsTouched(true)
    setSite(cleanedValue)
    if (isValidSite(value)) {
      setError(false)
      onChange(value)
    } else {
      setError(true)
      onChange("")
    }
  }

  return (
    <div className={`${s.siteInput} ${className}`}>
      <label htmlFor="site" className={`${s.customLabel} ${site ? s.hidden : ""}`}>
        Сайт<span>*</span>
      </label>
      <input id="site" type="text" className={`${isTouched ? (error ? s.invalid : s.success) : ""}`} value={site} onChange={handleInputChange} required />
      {error && <span className={s.error}>Введите корректный сайт в формате carrotquest.io</span>}
    </div>
  )
}

export default SiteInputValidate
